import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { SELECT_SUB_CUENTA } from "../utils/const/const-select-sub-cuenta";
import { existeUsuario } from "../api/api-usuario-web";

export default function ModalFormCrearSubUsuario({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();
    const [subUsuarioSelected, setSubUsuarioSelected] = useState(null);

    useEffect(() => {
        iniciar();
    }, [formData]);

    const iniciar = async () => {
        try {
            // console.log('formData');
            // console.log(formData);

        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const charLimits = {
        nombreUsuario: 32,
        password: 16,
        confirmPassword: 16,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = async () => {
        try {
            // console.log('validateForm');
            // console.log(formData);
            let message = "";
            if (subUsuarioSelected === null) {
                message = message + t("alert_must_user_type") + '\n';
            }
            if (String(formData.nombreUsuario).trim().length === 0) {
                message = message + t("alert_must_enter_nombre_usuario") + '\n';
            }
            if (String(formData.password).trim().length === 0) {
                message = message + t("alert_must_enter_password") + '\n';
            }
            if (String(formData.confirmPassword).trim().length === 0) {
                message = message + t("alert_must_enter_confirm_password") + '\n';
            }
            if (String(formData.password).trim() !== String(formData.confirmPassword).trim()) {
                message = message + t("alert_passwords_dont_match") + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            const resp = await existeUsuario(formData);
            // console.log('resp');
            // console.log(resp);
            if (resp.error === true) {
                alert(resp.message);
                return;
            }
            if (resp.total !== 0) {
                alert(t("alert_user_already_exists"));
                return;
            }
            formData.idSubUsuario = subUsuarioSelected.value;
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            nombreUsuario: "",
            password: "",
            confirmPassword: "",
        });
        setSubUsuarioSelected(null);
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white sm:p-2 md:p-4 lg:p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>
                        {/* <div className="rounded-lg w-1/2"> */}
                        {/* Inputs */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_select_tipo_usuario")}<span className="text-red-500">*</span></label>
                            <Select
                                options={SELECT_SUB_CUENTA}
                                isSearchable={true}
                                isClearable={true}
                                value={subUsuarioSelected}
                                onChange={(event) => {
                                    setSubUsuarioSelected(event);
                                }}
                                placeholder={t("label_select_tipo_usuario")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        {/* </div>
                        <div className="rounded-lg w-1/2">
                        </div> */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_username")}</label>
                            <input
                                name="nombreUsuario"
                                value={formData.nombreUsuario}
                                onChange={handleInputChange}
                                placeholder={t("placeholder_enter_user")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nombreUsuario.length}/{charLimits.nombreUsuario}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_password")}<span className="text-red-500">*</span></label>
                            <input
                                name="password"
                                value={formData.password}
                                onChange={handleInputChange}
                                placeholder={t("placeholder_enter_password")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.password.length}/{charLimits.password}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_confirm_password")}<span className="text-red-500">*</span></label>
                            <input
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                placeholder={t("placeholder_enter_confirm_password")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.confirmPassword.length}/{charLimits.confirmPassword}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
